/**
 * Conifguration related to the enterprise partner
 */

export const HIGHLIGHT_KEY = process.env.REACT_APP_HIGHLIGHT_KEY || 'k4g8w9g5';

export const TYPEFORM_URL =
  process.env.REACT_APP_TYPEFORM_URL ||
  'https://usekanda.typeform.com/to/Idc1wdwz#cid=';

export const SLACK_DELETE_ACCOUNT_WEBHOOK_URL =
  process.env.REACT_APP_SLACK_DELETE_ACCOUNT_WEBHOOK_URL ||
  'https://hooks.slack.com/services/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';
